import {
  TopMostExpensiveGroup,
  TopMostExpensiveGroupDatapoint,
} from '@cast/split-me/types';

import { useCrossAzCommunicationData } from './useCrossAzCommunicationData';

export type UseCrossAzCommunicationCostsDataResult = {
  topItems: TopMostExpensiveGroup[];
  datapoints: TopMostExpensiveGroupDatapoint;
  isLoading: boolean;
  isFetching: boolean;
  error?: Error;
  refetch: () => void;
};

export const useCrossAzCommunicationCostsData =
  (): UseCrossAzCommunicationCostsDataResult => {
    const { topItems, datapoints, isLoading, isFetching, error, refetch } =
      useCrossAzCommunicationData('interZoneCost');

    return {
      topItems,
      datapoints,
      isLoading,
      isFetching,
      error: error as Error | undefined,
      refetch,
    };
  };
